import classes from "./WelcomeMessage.module.css";
import apple from "./../../../assets/images/apple.png";
import android from "./../../../assets/images/android.png";
import information from "./../../../assets/images/information_project.png";
import { useTranslation } from "react-i18next";
import {
  androidAppLink,
  informationLink,
  informationLinkEN,
  iosAppLink,
  welcomeMessageContent,
} from "../../../../SMARTCITY/hardCodeData/DATA";
import { useContext } from "react";
import LanguageContext from "../../../hooks/language-context";
import { useHistory } from "react-router-dom";
import SvgTermsofuse2 from "../../../assets/icons/Termsofuse2";

import espa from "../../../assets/images/epsaNew.png";
import espaEn from "../../../assets/images/epsaNewEn.png";

const WelcomeMessage = () => {
  const { t } = useTranslation();
  const languageCtx = useContext(LanguageContext);
  const history = useHistory();
  return (
    <div className={classes.welcome_placeholder}>
      <div>
        <p>{t("welcomeMessageContent.part1")}</p>
        <p>{t("welcomeMessageContent.part2")}</p>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {/* <div className={classes.image_item}>
          <img
            src={languageCtx.languageCode === "en" ? espaEn : espa}
            alt="sponsor logo 2"
            width={"300px"}
          />
        </div> */}
        {/* <div
          className={classes.box_item}
          onClick={() => history.push("/terms-of-use")}
        >
          <SvgTermsofuse2 width={35} />
          {languageCtx.languageCode === "el" ? (
            <p>{t("Όροι Χρήσης")}</p>
          ) : (
            <p>{t("Terms of Use")}</p>
          )}
        </div> */}
        {/* <div
          className={classes.box_item}
          onClick={() => history.push("/accessibility")}
        >
          <SvgTermsofuse2 width={35} />
          {languageCtx.languageCode === "el" ? (
            <p>{t("Δήλωση Προσβασιμότητας")}</p>
          ) : (
            <p>{t("Accessibility Statement")}</p>
          )}
        </div> */}
        <div
          className={classes.box_item}
          onClick={() =>
            window.open(
              languageCtx.languageCode === "en"
                ? informationLinkEN
                : informationLink,
            )
          }
        >
          <img
            src={information}
            className={classes.inf_normal}
            alt={"information-application"}
            width={35}
          />
          <p>{t("Πληροφορίες για το έργο")}</p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeMessage;
